export const log = (type, payload, tag = null) => ({ type: `log/${type}`, payload, tag });
